import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "group" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "btn btn-custom",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickPdf && _ctx.clickPdf(...args)))
    }, [...(_cache[3] || (_cache[3] = [
      _createElementVNode("i", { class: "bi bi-filetype-pdf" }, null, -1)
    ]))]),
    _createElementVNode("button", {
      class: "btn btn-custom",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clickXlsx && _ctx.clickXlsx(...args)))
    }, [...(_cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "bi bi-filetype-xlsx" }, null, -1)
    ]))]),
    _createElementVNode("button", {
      class: "btn btn-custom",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clickCsv && _ctx.clickCsv(...args)))
    }, [...(_cache[5] || (_cache[5] = [
      _createElementVNode("i", { class: "bi bi-filetype-csv" }, null, -1)
    ]))]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}